import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import type { EditorState, Transaction } from '@tiptap/pm/state';
import { DESCRIPTION_CHARACTER_LIMIT } from '../utils/descriptionLimit';
import { docToMarkdown } from '../utils/stateToMarkdown';

const descriptionCharacterLimitKey = new PluginKey('descriptionCharacterLimit');

export type DescriptionCharacterLimitOptions = {
  limit: number;
};

export function createAllowDescriptionTransaction(limit: number) {
  return (tr: Transaction, state: EditorState): boolean => {
    if (!tr.docChanged) return true;
    // Use tr.doc directly — state.apply(tr) re-enters filterTransaction.
    const nextLen = docToMarkdown(tr.doc, state.schema).length;
    if (nextLen <= limit) return true;
    const prevLen = docToMarkdown(state.doc, state.schema).length;
    return nextLen < prevLen;
  };
}

/**
 * Blocks document changes that would make the stored markdown longer than `limit`.
 * Shrinks are still allowed when the description is already over the limit.
 */
export const DescriptionCharacterLimit = Extension.create<DescriptionCharacterLimitOptions>({
  name: 'descriptionCharacterLimit',

  addOptions() {
    return {
      limit: DESCRIPTION_CHARACTER_LIMIT
    };
  },

  addProseMirrorPlugins() {
    const allow = createAllowDescriptionTransaction(this.options.limit);
    return [
      new Plugin({
        key: descriptionCharacterLimitKey,
        filterTransaction: allow
      })
    ];
  }
});
